export default function Header() {
    return (
      <>
        <h1 className="mb-6 mt-6 font-bold text-3xl sm:text-4xl md:text-5xl lg:text-5xl text-white">
          Choose Your Trading Evolution Path
        </h1>
        <p className="text-lg md:text-xl text-gray-400 mb-10">
          Unlock the power of AI-driven trading strategies
        </p>
      </>
    );
  }